<template>
  <v-container fluid class="pa-0 ma-8 justify-center">
    <v-card
      v-for="msg in messages"
      :key="msg.id"
      hover
      class="d-flex justify-center align-center margin-auto pa-3 ma-3"
    >
      <span>
        <p>{{ msg.text }}</p>
        <p>{{ msg.created_at }}</p>
      </span>
    </v-card>
  </v-container>
  <overlay-loader v-model="loading" />
</template>
<script>
import repo from "@/store/repo.js";
import swalFun from "@/plugins/swalFun";
import OverlayLoader from "@/components/common/OverlayLoader.vue";

export default {
  components: {
    OverlayLoader,
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    messages() {
      return repo.messages.getAllMessages();
    },
  },
  methods: {
    async fetch() {
      this.loading = true;
      const res = await repo.messages.fetchAll();
      if (res) {
        //swalFun.success("success");
        // console.log(res2);
      } else {
        swalFun.fail("error");
      }
      this.loading = false;
    },
  },
  async mounted() {
    await this.fetch();
  },
};
</script>
